<!--
  La pagina resta montata sotto la schermata, ma inerte: niente fuoco, niente clic, niente lettura. Resta
  montata perche' smontarla chiuderebbe la conversazione e le sue connessioni, che il riavvio della
  connessione realtime deve poter ritrovare.
-->
<div class="app__content" [attr.inert]="blockingScreen() ? '' : null">
  <router-outlet></router-outlet>
</div>

<!-- Una schermata che blocca vince sull'apertura: e' quella la cosa da dire. -->
@if (isOpening() && !blockingScreen()) {
  <dxp-splash-screen
    [brandName]="brandName()"
    [label]="splashLabel()"
    [logoUrl]="logoUrl()"
  ></dxp-splash-screen>
}

@if (blockingScreen(); as screen) {
  <dxp-service-unavailable
    [labels]="screen.labels"
    [markUrl]="markUrl()"
    (actionRequested)="screen.act()"
  ></dxp-service-unavailable>
}
